import lodash from 'lodash';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Paper, InputBase, Divider, IconButton, Icon, Button, CircularProgress,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import Tooltip from '@material-ui/core/Tooltip';
// import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

const styles = (theme) => ({
    paper: {
        padding: '0 4px',
        display: 'flex',
        alignItems: 'center',
        // width: 400,
        // marginBottom: 10,
        height: '35px',
        marginRight: '5px',
    },
    input: {
        marginLeft: 8,
        flex: 1,
        fontSize: '14px',
    },
    iconButton: {
        padding: 4,
    },
    divider: {
        width: 1,
        height: 28,
        margin: 4,
    },
    progress: {
        // margin: theme.spacing.unit * 2,
        marginLeft: 5,
        marginRight: 5,
        color: '#00695c',
    },
    monuItem: {
        paddingTop: 'inherit',
    },
});

class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            anchorEl: null,
        };
    }

    handlerChange = (event) => {
        event.persist();

        const { onSearch } = this.props;

        if (lodash.isFunction(onSearch)) {
            onSearch(event.target.value);
        }
    };

    handleToggle = () => {
        this.setState((state) => ({ isOpen: !state.isOpen }));
    };

    handlerClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handlerClose = () => {
        this.setState({ anchorEl: null });
    };

    handlerClearSearch = () => {
        const { onSearch } = this.props;

        if (lodash.isFunction(onSearch)) {
            onSearch('');
        }
    }

    buildMenu() {
        const { menu } = this.props;
        const { anchorEl } = this.state;

        if (!menu || lodash.isEmpty(menu.items)) {
            return null;
        }

        const { classes } = this.props;

        return (
            <Paper className={classes.paper} elevation={1}>
                <Tooltip title="Table Menu" placement="top">
                    {/* <IconButton className={classes.iconButton} aria-label="Menu" onClick={this.handlerClick}>
                        <Icon fontSize={"small"} color={"inherit"}>menu</Icon>
                    </IconButton> */}
                    <Button
                        size="small"
                        startIcon={<MenuIcon />}
                        onClick={this.handlerClick}
                    >
                        Menu
                    </Button>
                </Tooltip>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handlerClose}
                    style={{ marginTop: 49 }}
                >
                    {
                        menu.items.map((item, itemIdx) => {
                            const content = [];

                            if (item.icon) {
                                content.push(<Icon
                                    key="icon"
                                    style={{ marginRight: 5 }}
                                    fontSize="small"
                                    color="inherit"
                                >
                                    {item.icon}
                                </Icon>);
                            }

                            content.push(<span key="content">{item.content}</span>);

                            return (
                                <MenuItem
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={itemIdx}
                                    onClick={(event) => {
                                        if (lodash.isFunction(item.onClick)) {
                                            item.onClick(event, item);
                                        }

                                        this.handlerClose(event, item);
                                    }}
                                    className={classes.monuItem}
                                >
                                    {content}
                                </MenuItem>
                            );
                        })
                    }
                </Menu>
            </Paper>
        );
    }

    render() {
        const {
            classes,
            onClickRefresh,
            searchStyle,
            searchPlaceholder,
            searchValue,
        } = this.props;

        return (
            <Fragment>
                {this.buildMenu()}

                <Paper className={classes.paper} elevation={1}>
                    <Tooltip title="Refresh Table Data" placement="top">
                        <IconButton className={classes.iconButton} aria-label="Refresh" onClick={onClickRefresh}>
                            <Icon fontSize="small" color="inherit">sync</Icon>
                        </IconButton>
                    </Tooltip>
                </Paper>
                <Paper className={classes.paper} elevation={1}>
                    {/* <Tooltip title={"Refresh Data"} placement="top">
                        <IconButton className={classes.iconButton} aria-label="Refresh" onClick={this.props.onClickRefresh}>
                            <Icon fontSize={"small"} color={"inherit"}>sync</Icon>
                        </IconButton>
                    </Tooltip>
                    <Divider className={classes.divider}/> */}
                    <IconButton disabled className={classes.iconButton} aria-label="Search">
                        <Icon fontSize="small" color="inherit">search</Icon>
                    </IconButton>

                    <InputBase
                        style={searchStyle}
                        className={classes.input}
                        placeholder={searchPlaceholder || 'Search...'}
                        onChange={this.handlerChange}
                        value={searchValue || ''}
                    />
                    <IconButton
                        style={{ visibility: lodash.isEmpty(searchValue) && 'hidden' }}
                        className={classes.iconButton}
                        aria-label="Clear Search"
                        onClick={this.handlerClearSearch}
                    >
                        <Icon fontSize="small" color="inherit">close</Icon>
                    </IconButton>
                    {/* <Divider className={classes.divider}/> */}
                    {/* <CircularProgress
                        className={classes.progress}
                        size={20}
                        thickness={4}
                    /> */}
                </Paper>
            </Fragment>
        );
    }
}

SearchBar.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SearchBar);



// WEBPACK FOOTER //
// ./src/components/table/SearchBar.js